/**
 * The locale list, in plain CommonJS so next.config.js can `require` it.
 *
 * Same reason as translatedRoutes.js: next.config.js cannot load TypeScript, and
 * it needs these three values for `i18n.locales` and for the returning-visitor
 * cookie redirects. Keeping one runtime copy means adding a language cannot leave
 * Next routing a locale the app does not know about, or the reverse.
 *
 * `locales.d.ts` declares these as literal types so `Locale` in config.ts is
 * still a union rather than plain `string`. Add a language in both files.
 */

/** Routing locales. The first one is the prefixless default. */
const LOCALES = ["en", "es"];

const DEFAULT_LOCALE = "en";

/** Next's convention. Its built-in detection reads the same name. */
const LOCALE_COOKIE = "NEXT_LOCALE";

/** Every locale except the default -- the ones that own a URL prefix. */
function prefixedLocales() {
  return LOCALES.filter((locale) => locale !== DEFAULT_LOCALE);
}

module.exports = {
  LOCALES,
  DEFAULT_LOCALE,
  LOCALE_COOKIE,
  prefixedLocales,
};
